import React from "react";
import { useSelector } from "react-redux";
import { ReactComponent as LoadingRing } from "../../assets/Icons/loadingRing.svg";

const Loading = () => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const buttonColor = projectInfo?.projectConfig?.config?.BUTTON_COLOR || '#000';
  const pubid = projectInfo?.projectConfig?.pubid;
  
  if (pubid === 50136) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", background: "#141414" }}>
        <img src={require("../../assets/Icons/BloodStream-loader.gif")} alt="Loading..." style={{ width: 120, height: 120 }} />
      </div>
    );
  }
  return (
    <div className="loadingContainer">
      <div className="loadingContent">
        <div className="loadingOverlay"></div>
        <div className="loading-container">
        <span class="loader" style={{ '--button-color': buttonColor }}></span>
        </div>
      </div>
    </div>
  );
};

export default Loading;
